var map = {
	"./account.js": "035a",
	"./address.js": "7a07",
	"./agreement.js": "9f3c",
	"./doctor.js": "e3cc",
	"./dpbind.js": "b45d",
	"./follow-up.js": "eb12",
	"./form.js": "b7d8",
	"./h5.js": "aa1d",
	"./health.js": "4190",
	"./im.js": "ad9e",
	"./indicator.js": "8785",
	"./information.js": "5a24",
	"./joint-manage.js": "2929",
	"./main.js": "764a",
	"./message.js": "b746",
	"./my.js": "33ad",
	"./order.js": "3697",
	"./other.js": "4853",
	"./pay.js": "8171",
	"./physician-visits.js": "1f18",
	"./remind.js": "bb38",
	"./report-manage.js": "a0d9",
	"./risk.js": "f420",
	"./service-pack.js": "499b",
	"./task.js": "bff4",
	"./xinyong.js": "a725"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a3dd";